
export const ENV_NAME = import.meta.env.VITE_ENV_NAME;

// export const appType = import.meta.env.VITE_PORTAL_NAME;
export const appType = 'UDH';
export const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const AUTH_URL = import.meta.env.VITE_AUTH_URL;
export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID;
export const MSAL_API_CLIENT_ID = import.meta.env.VITE_MSAL_API_CLIENT_ID;
export const MSAL_TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID;
export const MSAL_REDIRECT_URI = import.meta.env.VITE_MSAL_REDIRECT_URI;
export const MSAL_LOGOUT_REDIRECT_URI = import.meta.env
  .VITE_MSAL_LOGOUT_REDIRECT_URI;
